<template>
  <div class="CurrencyMenu">
    <DropdownMenu :dropped.sync="isDropped">
      <span
        slot="label"
        class="CurrencyMenu__Label-Large d-none d-md-inline hidden-xs-down"
      >
        {{ currentCurrency }}
      </span>
      <span
        slot="label"
        class="CurrencyMenu__Label-Small d-md-none"
      >
        {{ currentCurrencyCode }}
      </span>

      <div slot="dropdown" class="CurrencyMenu__List">
        <button
          class="CurrencyMenu__List-Item"
          v-for="currency in currencies"
          :key="currency.symbol"
          @click="setCurrencyAndClose(currency.symbol)"
        >
          {{ getCurrencyNameBySymbol(currency.label) || currency.label }}
          <i
            class="fa fa-check"
            v-if="currency.symbol === $store.state.currency"
          ></i>
          <em>{{ currency.symbol }}</em>
        </button>
      </div>
    </DropdownMenu>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NumbersMixin from "@/mixins/numbers";
import DropdownMenu from "./DropdownMenu";

export default {
  name: "CurrencyMenu",
  mixins: [NumbersMixin],
  components: {
    DropdownMenu,
  },
  data() {
    return {
      isDropped: false,
    };
  },
  computed: {
    currentCurrency() {
      return (
        this.getCurrencyNameBySymbol(this.$store.state.settings.currency) ||
        this.$store.state.settings.currency
      );
    },
    currentCurrencyCode() {
      return (
        this.getCurrencyCodeBySymbol(this.$store.state.settings.currency) ||
        this.$store.state.settings.currency
      );
    },
    ...mapGetters({
      currencies: "currency/currencies",
    }),
  },
  methods: {
    setCurrencyAndClose(currency) {
      this.setCurrency({ currency });
      this.isDropped = false;
    },
    ...mapActions({
      setCurrency: "settings/setCurrency",
    }),
  },
};
</script>

<style lang="scss">
@import "~@/scss/variables";
@import "~@/scss/mixins";

.CurrencyMenu {
  display: inline-block;
  @include breakpoint-manual(max-width, $break-extra-small - 1px) {
    .DropdownMenu__List {
      right: -20px;
    }
  }
}

.CurrencyMenu__List {
  width: 205px;
  height: 320px;
  @include breakpoint-manual(min-width, $break-small) {
    width: 225px;
  }
}

.CurrencyMenu__List-Item {
  cursor: pointer;
  white-space: nowrap;
  padding: 5px 13px;
  display: block;
  color: #222;
  text-decoration: none;
  border: 0;
  background: none;
  width: 100%;
  text-align: left;
  font-size: 16px;
  transition: background 0.1s;

  &:nth-child(4) {
    margin-bottom: 12px;
  }

  &[disabled] {
    background: transparent !important;
    color: #999 !important;
    cursor: not-allowed;
  }

  &:hover {
    color: $color-secondary;
    background: #f4f4f4;
  }

  em {
    float: right;
    font-weight: 300;
    margin-left: 5px;
    opacity: 0.5;
    font-style: normal;
  }

  @include breakpoint-manual(min-width, $break-small) {
    padding: 5px 20px;
  }
}
</style>
